const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const aircraftmapLegendFactory = require('components/bags_and_seats/aircraftmap_legend/js/main.desktop');

const AirCraftMapWidgetHelper = require('components/bags_and_seats/aircraftmap_utils/js/aircraftmap.helper');
const AircraftMapTemplate = require('components/bags_and_seats/aircraftmap_manager/js/aircraftmap_desktop');
const aircraftMapUtils = require('components/bags_and_seats/aircraftmap_utils/js/aircraftmap.utils');

const ShoppingCart = require('od-modules/cart/cart');

const SeatsTracking = require('../../../../webapp/static-content/_versionedByRelease_/js/tracking/bags_and_seats/seats_tracking').getInstance();

const CONS = {
    DATA_STATUS: 'data-status',
    STATUS_AVAILABLE: 'available',
    STATUS_UNAVAILABLE: 'unavailable',
    STATUS_ACTIVE: 'active',
    STATUS_INACTIVE: 'inactive',
    STATUS_SELECTED: 'selected',
    STATUS_VISIBLE: 'visible',
    STATUS_HIDDEN: 'hidden',
    STATUS_CLOSED: 'closed',
    STATUS_NO_SEAT: 'no_seat',
    STATUS_OUTBOUND: 'outbound',
    STATUS_INBOUND: 'inbound',
    STATUS_CLASS_DISABLED: 'odf-text-mono-color-06',
    SCROLL_TOP_OFFSET: 20,
    SCROLL_ANIMATION_DURATION: 800,
    CMS_REGEX: '%1$s',
    SEAT_HEIGHT: 35,
    SEAT_WIDTH: 35,
    SEAT_SELECTED: true,
    SEAT_UNSELECTED: false,
    SEAT_HOVER_CLASS: 'od-aircraftmap-seat-preview-hover',
    HIDDEN_CLASS: 'odf-hidden',
    PASSENGER_TYPE_ADULT: 'ADULT',
    PASSENGER_TYPE_CHILDREN: 'CHILDREN',
    PASSENGER_TYPE_INFANT: 'INFANT',
    AIRCRAFT_LOADER_TIMEOUT: 1000,
    AIRCRAFT_NO_SEATS_TIMEOUT: 2500,
    ICON_PAX: 'odf-icon-pax',
    ICON_X_LEG: 'odf-icon-x-leg-room',
    ICON_PREFERRED: 'odf-icon-crown',
    ICON_CHEAPER: 'odf-icon-tag',
    SEAT_SELECTOR: '.aircraftmap_seat',
    SELECTED_SEAT_SELECTOR: '.aircraftmap_seat_available[data-status="selected"]',
    AVAILABLE_SEAT_SELECTOR: '.aircraftmap_seat_available',
};

module.exports = withRenderedMain(withCachedSelectors(BaseView.extend(AirCraftMapWidgetHelper.extend({
    selectors: {
        aircraftContainer: '.aircraftmap_container',
        aircraftmapFlightSectionText: '.aircrafmap_flight_section_text',
        aircraftmapFlightSectionTextSmall: '.aircrafmap_flight_section_text_small',
        aircraftmapFlightSectionType: '.aircrafmap_flight_section_type',
        aircraftmapHeaderFlightSegment: '.aircraftmap_header_flight_segment',
        aircraftmapMask: '.aircraftmap_mask',
        aircraftmapMinimumPrice: '.aircraftmap_textblock',
        aircraftmapFrompriceContainer: '.aircraftmap_fromprice_container',
        aircraftmapMinimumPricePrime: '.aircraftmap_textblock_prime',
        aircraftmapMinimumPriceValue: '.aircraftmap_minimumPrice_value',
        aircraftmapMinimumPriceValuePrime: '.aircraftmap_minimumPrice_valuePrime',
        aircraftmapNextSectionButton: '.aircraftmap_next_button',
        aircraftmapNoContent: '.aircraftmap_no_content',
        aircraftmapNoContentImage: '.aircraftmap_noseatmap_image',
        aircraftmapPrevButton: '.aircraftmap_prev_button',
        aircraftmapRetainButton: '.aircraftmap_retainselection',
        aircraftmapRibbonSlider: '.aircraftmap_ribbon_slider',
        aircraftmapSaveButton: '.aircraftmap_save_selection',
        aircraftmapSeatAvailable: '.aircraftmap_seat_available',
        aircraftmapUidialogOK: '.aircraftmap_ui_dialog_OK',
        aircraftmapSectionLoader: '.seatmap_section_loader',
        aircraftmapMoveThroughSpinner: '.move_through_spinner',
        aircraftmapMoveThroughSuccess: '.move_through_success',
        aircrafmapLegend: '.aircrafmap_legend',
        aircraftmapLegendPreferred: '.legend_preferred_seat',
        aircraftmapLegendExtraLeg: '.legend_extra_leg_room_seat',
        aircraftmapLegendStandard: '.legend_standard_seat',
        aircraftmapLegendCheapest: '.legend_cheapest_seat',
        aircraftmapLegendClickable: '.legend_clickable_type',
        aircraftmapCurrentSection: '.aircraft_current_section',
        aircraftmapWrapper: '.aircraftmap_wrapper',
        aircraftmapPreview: '.aircraftmap_seat_preview',
        aircraftmapPreviewImage: '.aircraftmap_seat_preview_image',
        aircraftmapPreviewSeatType: '.aircraftmap_seat_preview_type',
        aircraftmapPreviewSeatId: '.aircraftmap_seat_preview_number',
        aircraftmapPreviewSeatPrice: '.aircraftmap_seat_preview_price',
        aircraftmapPreviewSeatPricePrime: '.aircraftmap_seat_preview_price_prime',
        aircraftmapPreviewSeatPriceContainer: '.aircraftmap_seat_preview_price_container',
        aircraftmapPreviewSeatPricePrimeContainer: '.aircraftmap_seat_preview_price_prime_container',
        aircraftmapPreviewSeatExtraLeg: '.aircraftmap_seat_preview_extra_leg',
    },
    events: {
        'tap .aircraftmap_next_button': 'onTapNextButton',
        'tap .aircraftmap_noseatmap_image': 'onTapAircraftMapNoContentImage',
        'tap .aircraftmap_prev_button': 'onTapPrevButton',
        'tap .aircraftmap_retainselection': 'onTapRetainSelection',
        'tap .aircraftmap_save_selection': 'onTapConfirmSeats',
        'tap .legend_clickable_type': 'onTapLegendSeatType',
        'tap .aircraftmap_deleteselection': 'onTapRemoveSelection',
        'tap .aircraftmap_seat': 'onTapSeat',
        'tap .aircraftmap_user_delete': 'onTapDeleteButton',
        'mouseover .aircraftmap_seat': 'onSeatHover',
        'mouseout .aircraftmap_seat': 'onSeatOut',
    },
    nTravellers: 0,
    defaultPassengerSelectString: '',
    segment: '',
    section: '',
    seatMap: [],
    aircraftLoaderTimeout: 0,
    aircraftMapLegendWidget: null,

    buildTemplate: function() {
        const preferredSeatsThreshold = aircraftMapUtils.getSectionPreferredThreshold(this.section,
            this.options.preferredSeatsThreshold);
        var opts = {
            keys: {
                unavailable: this.keys.unavailable,
                window: this.keys.window,
                aisle: this.keys.aisle,
                middle: this.keys.middle,
                rowPrice: this.keys.rowPrice,
                darkzoneSingleRow: this.keys.darkzoneSingleRow,
                darkzoneMultiRow: this.keys.darkzoneMultiRow,
            },
            seatMap: this.seatMap,
            preferredSeatsThreshold,
        };
        const aircraftMapTemplate = new AircraftMapTemplate(opts);
        return aircraftMapTemplate.buildTemplate();
    },
    setUpView: function(seatMap, extraOptions) {
        const completeOptions = Odigeo._.extend({}, extraOptions, Odigeo.BagsAndSeats);
        this.options = Odigeo._.extend({}, this.options, completeOptions);
        this.seatMap = seatMap;
        this.nTravellers = this.options.nTravellers || Odigeo._.size(this.passengerCollection);
        this.nEligibleTravellers = this.options.nEligibleTravellers || this.getEligibleTravellersCount();
        this.section = this.options.section;
        this.segment = this.options.segment;
        this.itinerarySectionsCount = this.getItinerarySectionsCount(this.options.itinerarySectionsCount, this.options, extraOptions);
        this.isMultiDestination = this.isMultidestinationAircraftMap(this.options.isMultiDestination, this.options, extraOptions);
        this.multiSegmentText = [this.keys.firstSegment, this.keys.secondSegment, this.keys.thirdSegment,
            this.keys.fourthSegment, this.keys.fifthSegment, this.keys.sixthSegment];
        this.defaultPassengerSelectString = this.options.defaultPassengerSelectString;
    },
    isMultidestinationAircraftMap: function(isMultiDestination, aircraftInfo, options) {
        if (Odigeo._.isUndefined(aircraftInfo.isMultiDestination) && Odigeo._.isUndefined(options)) {
            return undefined;
        }
        return Odigeo._.isUndefined(isMultiDestination) ?
            aircraftInfo.isMultiDestination || Odigeo._.get(options, 'isMultiDestination', false) :
            isMultiDestination;
    },
    getItinerarySectionsCount: function(itinerarySectionsCount, aircraftInfo, options) {
        if (Odigeo._.isUndefined(aircraftInfo.itinerarySectionsCount) && Odigeo._.isUndefined(options)) {
            return undefined;
        }
        return Odigeo._.isUndefined(itinerarySectionsCount) ?
            aircraftInfo.itinerarySectionsCount || Odigeo._.get(options, 'itinerarySectionsCount', 0) :
            itinerarySectionsCount;
    },
    onTapAircraftMapNoContentImage: function() {
        this.options.isLast ? this.tapButton('prev') : this.tapButton('next');
    },
    onTapConfirmSeats: function() {
        if (this.seatMapSelectionCollection.length > 0) {
            this.closeAircraftMap();
        } else {
            Odigeo.trigger(this.name + ':showNoSeatsSelectedDialog');
        }
    },
    onTapNextButton: function() {
        if (this.isNavigationButtonEnabled(this.$cachedSelectors.aircraftmapNextSectionButton)) {
            this.cancelAircraftMoveThrough();
            this.tapButton('next', {userInteraction: true});
            Odigeo.trigger(this.name + ':scrollToSeatMapSelection');
        }
    },
    onTapPrevButton: function() {
        if (this.isNavigationButtonEnabled(this.$cachedSelectors.aircraftmapPrevButton)) {
            this.cancelAircraftMoveThrough();
            this.tapButton('prev', {userInteraction: true});
            Odigeo.trigger(this.name + ':scrollToSeatMapSelection');
        }
    },
    toggleNavigationButton: function($navButton, toggle) {
        $navButton.toggleClass(CONS.STATUS_CLASS_DISABLED, toggle);
    },
    isNavigationButtonEnabled: function($navButton) {
        return !$navButton.hasClass(CONS.STATUS_CLASS_DISABLED);
    },
    onSeatHover: function(event) {
        const $seat = $(event.target);
        const showPreview = $seat.attr('data-type') !== CONS.STATUS_UNAVAILABLE && $seat.attr('data-type') !== CONS.STATUS_NO_SEAT;

        if (showPreview) {
            this.fillContentPreview($seat);
            this.$cachedSelectors.aircraftmapPreview.offset(this.getNewPositionPreview($seat));
            this.$cachedSelectors.aircraftmapPreview.animate({top: '-=5'}, 1000);
            this.$cachedSelectors.aircraftmapPreview.addClass(CONS.SEAT_HOVER_CLASS);
        }
    },
    onSeatOut: function() {
        this.closeSeatPreviewPopOver();
    },
    fillContentPreview: function($seat) {
        const type = $seat.attr('data-type');
        const textType = $seat.attr('data-texttype');
        const rowCount = $seat.attr('data-row');
        const columnCount = $seat.attr('data-column');
        const isExtraLeg = ($seat.attr('data-extra-leg') === 'true');
        const price = $seat.attr('data-price');
        const primePrice = $seat.attr('data-prime-price');
        const hidePreviewExtraLegSeat = !isExtraLeg;

        this.$cachedSelectors.aircraftmapPreviewSeatExtraLeg.toggleClass(CONS.HIDDEN_CLASS, hidePreviewExtraLegSeat);

        this.$cachedSelectors.aircraftmapPreviewImage.attr('data-img', type);
        this.$cachedSelectors.aircraftmapPreviewSeatType.text(textType);
        this.$cachedSelectors.aircraftmapPreviewSeatId.text(rowCount + columnCount);
        this.$cachedSelectors.aircraftmapPreviewSeatPrice.html(price);
        this.$cachedSelectors.aircraftmapPreviewSeatPricePrime.html(primePrice);
    },
    closeSeatPreviewPopOver: function() {
        this.$cachedSelectors.aircraftmapPreview.removeClass(CONS.SEAT_HOVER_CLASS);
    },
    getNewPositionPreview: function($seat) {
        const seatPosition = $seat.offset();
        const previewHeight = this.$cachedSelectors.aircraftmapPreview.height();
        const previewWidth = this.$cachedSelectors.aircraftmapPreview.width();
        const previewTopPosition = seatPosition.top - previewHeight - CONS.SEAT_HEIGHT / 2;
        const previewLeftPosition = seatPosition.left + CONS.SEAT_WIDTH / 2 - previewWidth / 2;

        return {top: previewTopPosition, left: previewLeftPosition};
    },
    getEligibleTravellersCount: function() {
        return this.passengerCollection.passengerCountByType(CONS.PASSENGER_TYPE_ADULT)
            + this.passengerCollection.passengerCountByType(CONS.PASSENGER_TYPE_CHILDREN);
    },
    tapButton: function(action, options) {
        Odigeo.trigger(`${this.name}:tapNavigateButton${this.getEventSuffix()}`,
            {segment: this.segment, section: this.section},
            action, options
        );
    },
    isCheckIn() {
        return Odigeo._.get(this, 'options.isCheckin');
    },
    getEventSuffix() {
        return this.isCheckIn() ? 'CheckIn' : '';
    },
    scrollToFirstSeatType: function(seatTypeClassName) {
        const $targetSeat = this.$cachedSelectors.aircraftContainer.find('.' + seatTypeClassName);
        if ($targetSeat.length) {
            this.nativeScrollAircraftMap($targetSeat.first().offsetParent());
        }
    },
    autoScrollAircraftMap: function(aircraftOptions) {
        const lastSeatSelectionType = Odigeo._.get(aircraftOptions, 'lastSeatSelectionType', '');
        const lastSeatSelectionClass = aircraftMapUtils.getSeatCharacteristicClassByType(lastSeatSelectionType);
        let $targetSeat = aircraftMapUtils.getSeatByClasses(this.$cachedSelectors.aircraftContainer, [
            `${CONS.SELECTED_SEAT_SELECTOR} ${CONS.SEAT_SELECTOR}`,
            `.${lastSeatSelectionClass}${CONS.SEAT_SELECTOR}`,
            `[data-rawprice="${+this.options.minimumPrice}"] ${CONS.SEAT_SELECTOR}`,
            `${CONS.AVAILABLE_SEAT_SELECTOR} ${CONS.SEAT_SELECTOR}`,
        ]);

        this.nativeScrollAircraftMap($targetSeat.offsetParent());
    },
    nativeScrollAircraftMap: function($targetSeat) {
        if ($targetSeat.length) {
            const isEmergencyExitSeat = aircraftMapUtils.isEmergencyExitSeat($targetSeat);
            const $targetScrollReference = isEmergencyExitSeat ? $targetSeat.offsetParent() : $targetSeat;

            Odigeo.Utils.scrollToElement($targetScrollReference, {
                container: this.selectors.aircraftmapMask,
                animation: true,
                extraTop: CONS.SCROLL_TOP_OFFSET,
            });
        }
    },
    onTapRetainSelection: function() {
        if (Odigeo._.size(this.seatMapSelectionCollection.getFlightSeats(this.section)) === this.nTravellers) {
            this.closeAircraftMap();
        }
    },
    onTapRemoveSelection() {
        this.removeAllSelection();
        this.closeAircraftMap();
        this.analyticsEventTracking({label: 'seats_gds_remove_nag_remove'});
    },
    onTapSeat(e) {
        const $el = this.$el.find(e.target);
        const seatStatus = this.getStatusValue($el.parent());
        if (seatStatus === CONS.STATUS_AVAILABLE && !this.allPaxHaveSeatInSection(this.segment, this.section)) {
            SeatsTracking.trackSelectSeat({passenger: this.getActivePassenger(), section: this.section + 1}, 'click');
            this.addSelectedSeat($el);
            this.onSeatOut();
            this.changeSeatIcon($el, CONS.SEAT_SELECTED);
            this.setStatusValue($el.parent(), CONS.STATUS_SELECTED);
            if (this.options.pristineMoveThrough) {
                this.moveToNextSection();
            }
        } else if (seatStatus === CONS.STATUS_SELECTED) {
            this.removeSelectedSeat($el);
            this.onSeatOut();
            this.changeSeatIcon($el, CONS.SEAT_UNSELECTED);
            this.setStatusValue($el.parent(), CONS.STATUS_AVAILABLE);
        }

        Odigeo.trigger(`${this.name}:updateSeatSelectionFees${this.getEventSuffix()}`);
    },
    changeSeatIcon: function($element, isSeatSelected) {
        isSeatSelected ? this.removeSpecialSeatIcon($element) : this.printAvailableSeat($element);
    },
    printAvailableSeat: function($element) {
        return this.isSpecialSeat($element) ? this.addSpecialSeatIcon($element) : $element.removeClass(CONS.ICON_PAX);
    },
    isSpecialSeat: function($element) {
        return $element.hasClass(aircraftMapUtils.constants.SMART_JS_CLASS) ||
            $element.hasClass(aircraftMapUtils.constants.EXTRA_JS_CLASS) ||
            $element.hasClass(aircraftMapUtils.constants.PREFERRED_JS_CLASS);
    },
    removeSpecialSeatIcon: function($element) {
        $element.removeClass([CONS.ICON_PREFERRED, CONS.ICON_X_LEG, CONS.ICON_CHEAPER].join(' '))
            .addClass(CONS.ICON_PAX);
    },
    addSpecialSeatIcon: function($element) {
        $element.removeClass(CONS.ICON_PAX).addClass(this.getSpecialSeatIcon($element));
    },
    getSpecialSeatIcon: function($element) {
        return $element.hasClass(aircraftMapUtils.constants.SMART_JS_CLASS) ?
            CONS.ICON_CHEAPER : $element.hasClass(aircraftMapUtils.constants.EXTRA_JS_CLASS) ?
                CONS.ICON_X_LEG : CONS.ICON_PREFERRED;
    },
    onTapDeleteButton(e) {
        const $el = this.$el.find(e.target);
        const divId = $el.parent().parent().attr('id');
        const numPassenger = parseInt(divId.charAt(divId.length-1), 10);
        const searchPattern = {numPassenger, section: this.section};
        const selectedSeat = this.seatMapSelectionCollection.getSeat(searchPattern);

        if (!Odigeo._.isEmpty(selectedSeat)) {
            this.deselectSeat(selectedSeat);
        }
        this.removeSelection(selectedSeat);
        SeatsTracking.trackSelectSeat({passenger: numPassenger, section: this.section + 1}, 'remove');
    },
    deselectSeat: function(selectedSeat) {
        const selectedSeatRow = selectedSeat.get('rowSelection');
        const selectedSeatColumn = selectedSeat.get('columnSelection');
        const $selectedSeat = this.$el.find(`#aircraft_map_${selectedSeatRow}${selectedSeatColumn}`);

        if ($selectedSeat.length) {
            this.setStatusValue($selectedSeat, CONS.STATUS_AVAILABLE);
            this.changeSeatIcon($selectedSeat.find('.aircraftmap_seat'), CONS.SEAT_UNSELECTED);
        }
    },
    closeAircraftMap: function() {
        Odigeo.trigger(`${this.name}:closeAircraftMap${this.getEventSuffix()}`);
    },
    trackCloseAircraftMap: function() {
        Odigeo.trigger(this.name + ':trackCloseAircraftMap');
    },
    moveToNextSection: function() {
        if (this.allPaxHaveSeatInSection(this.segment, this.section)) {
            if (!this.options.isLast) {
                const selectedSeatSelector = `${CONS.SELECTED_SEAT_SELECTOR} ${CONS.SEAT_SELECTOR}`;
                const lastSeatSelectionType = aircraftMapUtils.getLastSeatSelectionType(this.$el, selectedSeatSelector);
                this.tapButton('next', {
                    showLoader: true,
                    lastSeatSelectionType,
                });
            } else {
                this.$cachedSelectors.aircraftmapMoveThroughSuccess.removeClass(CONS.HIDDEN_CLASS);
                this.$cachedSelectors.aircraftmapMoveThroughSpinner.addClass(CONS.HIDDEN_CLASS);
                this.$cachedSelectors.aircraftmapSectionLoader.addClass('fadeIn');
                this.trackCloseAircraftMap();
                this.aircraftLoaderTimeout = setTimeout(Odigeo._.bind(function() {
                    this.$cachedSelectors.aircraftmapSectionLoader.removeClass('fadeIn');
                    this.closeAircraftMap();
                    this.$cachedSelectors.aircraftmapMoveThroughSuccess.toggleClass(CONS.HIDDEN_CLASS);
                    this.$cachedSelectors.aircraftmapMoveThroughSpinner.toggleClass(CONS.HIDDEN_CLASS);
                }, this), CONS.AIRCRAFT_LOADER_TIMEOUT);
            }
        }
    },
    setupAircraftWithLoader: function(seatMap, aircraftOptions) {
        if (aircraftOptions.pristineMoveThrough) {
            this.$cachedSelectors.aircraftmapSectionLoader.addClass('fadeIn');
            this.aircraftLoaderTimeout = setTimeout(Odigeo._.bind(function() {
                this.$cachedSelectors.aircraftmapSectionLoader.removeClass('fadeIn');
                this.setupAircraft(seatMap, aircraftOptions);
            }, this, seatMap), CONS.AIRCRAFT_LOADER_TIMEOUT);
        }
    },
    setupAircraft: function(seatMap, aircraftOptions) {
        this.setUpView(seatMap, aircraftOptions);
        this.updateShoppingCart();
        if (!Odigeo._.isEmpty(seatMap)) {
            this.renderPassengersTemplate();
            this.renderAircraftTitle();
            this.renderAircraftStructure();
            this.renderSelection();
            this.activateItinerary();
        } else {
            this.desactivateItinerary(aircraftOptions);
        }
        this.cacheDomSelectors();
        this.updateCommonElements();
        this.delegateEvents();
        this.autoScrollAircraftMap(aircraftOptions);
    },
    openAircraftMap: function(seatMap, aircraftOptions) {
        this.openAircraftMapSetup(seatMap, aircraftOptions);
        this.closeSeatPreviewPopOver();
        if (aircraftOptions.showLoader) {
            this.setupAircraftWithLoader(seatMap, aircraftOptions);
        } else {
            this.setupAircraft(seatMap, aircraftOptions);
        }
    },
    render: function() {
        this.renderPassengersInfo();
        this.renderSelection();
        this.updateCommonElements();
    },
    desactivateItinerary: function(aircraftOptions) {
        this.setStatusValue(this.$cachedSelectors.aircraftmapWrapper, CONS.STATUS_HIDDEN);
        this.setStatusValue(this.$cachedSelectors.aircraftmapNoContent, CONS.STATUS_VISIBLE);
        if (aircraftOptions.pristineMoveThrough && !this.options.isFirst && !this.options.isLast) {
            this.aircraftLoaderTimeout = setTimeout(Odigeo._.bind(function() {
                this.tapButton('next', {showLoader: true});
                this.activateItinerary();
            }, this), CONS.AIRCRAFT_NO_SEATS_TIMEOUT);
        }
    },
    activateItinerary: function() {
        this.setStatusValue(this.$cachedSelectors.aircraftmapWrapper, CONS.STATUS_VISIBLE);
        this.setStatusValue(this.$cachedSelectors.aircraftmapNoContent, CONS.STATUS_HIDDEN);
    },
    cacheDomSelectors: function() {
        this.updateDomSelectorsToCache();
    },
    renderAircraftTitle: function() {
        const segmentTypeText = this.isMultiDestination ?
            this.multiSegmentText[this.segment] :
            this.segment === 0 ? this.keys.outboundSegmentText : this.keys.inboundSegmentText;

        this.$cachedSelectors.aircraftmapHeaderFlightSegment.html(segmentTypeText);
        this.$cachedSelectors.aircraftmapFlightSectionText.html(this.options.flightSection);
        this.$cachedSelectors.aircraftmapFlightSectionTextSmall.html(this.options.flightSectionSmall);
    },
    renderPassengersTemplate: function() {
        this.passengerCollectionLoadedPromise.then(Odigeo._.bind(function() {
            this.$el.find('.aircraftmap_users').html(this.templates.aircraftmapPassengers({
                passengers: this.passengerCollection.toJSON(),
                keys: this.keys,
            }));
            this.renderPassengersInfo();
        }, this));
    },
    renderPassengersInfo: function() {
        let $activePassenger;
        this.passengerCollection.each(function(model) {
            const idPassenger = model.get('numPassenger');
            const passengerDivId = this.getPassengerDivId(idPassenger);
            const searchPattern = {numPassenger: idPassenger, section: this.section};
            const seatSelected = this.seatMapSelectionCollection.getSeat(searchPattern);
            const isSeatSelected = !Odigeo._.isEmpty(seatSelected);
            const deleteButtonStatus = isSeatSelected ? CONS.STATUS_VISIBLE : CONS.STATUS_HIDDEN;
            const text = isSeatSelected ? this.getSeatInfo(seatSelected) : this.defaultPassengerSelectString;

            $activePassenger = this.$el.find(passengerDivId);
            this.setStatusValue($activePassenger, CONS.STATUS_INACTIVE);
            this.setRemoveButtonStatus(this.$el.find(passengerDivId + ' .aircraftmap_user_delete'), deleteButtonStatus, text);
            this.$el.find(passengerDivId + ' .aircraftmap_user_seat').html(text);
            this.$el.find(passengerDivId + ' .aircraftmap_user_seat').toggleClass('od-aircraftmap-user-seat-number-filled', isSeatSelected);

            if (!Odigeo._.isEmpty(model.get('name'))) {
                const fullName = `${model.get('name')} ${model.get('firstLastName')}`;
                this.$el.find(passengerDivId + ' .aircraftmap_user_name').html(fullName);
            }
        }, this);
        $activePassenger = this.$el.find(this.getPassengerDivId(this.getActivePassenger()));
        this.setStatusValue($activePassenger, CONS.STATUS_ACTIVE);
    },
    setRemoveButtonStatus: function($el, deleteButtonStatus, selectedSeatText) {
        const dataSelectedSeat = selectedSeatText !== this.defaultPassengerSelectString ? selectedSeatText : '';
        this.setStatusValue($el, deleteButtonStatus);
        $el.attr('data-selected-seat', dataSelectedSeat);
    },
    renderAircraftStructure: function() {
        const aircraftTemplate = this.buildTemplate();
        const seatTypeAvailable = aircraftMapUtils.getSeatTypeAvailable(aircraftTemplate);
        this.$cachedSelectors.aircraftContainer.empty().html(aircraftTemplate);
        this.initAircraftLegend(seatTypeAvailable);
    },
    renderAvailableSeats: function() {
        this.seatMapDescriptorCollection.each(function(model) {
            const $seatDivId = this.$el.find(this.getSeatDivId(model.get('seatRow'), model.get('column')));
            const isNoSeat = model.get('type') === 'NO_SEAT';
            const status = isNoSeat ? CONS.STATUS_NO_SEAT : CONS.STATUS_AVAILABLE;
            this.setStatusValue($seatDivId, status);
        }, this);
    },
    renderSelection: function() {
        this.setStatusValue(this.$cachedSelectors.aircraftmapSeatAvailable, CONS.STATUS_AVAILABLE);
        const seatsSelectionOfAircraft = this.seatMapSelectionCollection.getFlightSeats(this.section);
        Odigeo._.each(seatsSelectionOfAircraft, function(model) {
            var $seatDivId = this.$el.find(this.getSeatDivId(model.get('rowSelection'), model.get('columnSelection')));
            this.changeSeatIcon($seatDivId.find('.aircraftmap_seat'), CONS.SEAT_SELECTED);
            this.setStatusValue($seatDivId, CONS.STATUS_SELECTED);
        }, this);
    },
    addSelectedSeat: function($el) {
        const searchPattern = {seatRow: $el.data('row'), column: $el.data('column')};
        const seat = {
            numPassenger: this.getActivePassenger(),
            segment: this.segment,
            section: this.section,
            seat: this.seatMapDescriptorCollection.getSeat(searchPattern),
        };
        this.addSelection(seat);
    },
    removeSelectedSeat: function($el) {
        const searchPattern = {rowSelection: $el.data('row'), columnSelection: $el.data('column'), section: this.section};
        const seat = this.seatMapSelectionCollection.getSeat(searchPattern);
        SeatsTracking.trackSelectSeat({passenger: seat.get('numPassenger'), section: this.section + 1}, 'remove');
        this.removeSelection(this.seatMapSelectionCollection.getSeat(searchPattern));
    },
    updateCommonElements: function() {
        const seatMapMinimumPriceText = this.$cachedSelectors.aircraftmapMinimumPrice.attr('data-minimum')
            ? this.$cachedSelectors.aircraftmapMinimumPrice.attr('data-minimum')
            : '';

        this.toggleNavigationButton(this.$cachedSelectors.aircraftmapNextSectionButton, this.options.isLast);
        this.toggleNavigationButton(this.$cachedSelectors.aircraftmapPrevButton, this.options.isFirst);
        this.$cachedSelectors.aircraftmapCurrentSection.html(Odigeo.Utils.replaceCmsKeyArgs(
            this.keys.flightIndex,
            this.options.section + 1,
            this.itinerarySectionsCount
        ));

        this.$cachedSelectors.aircraftmapMinimumPrice.html(seatMapMinimumPriceText
            .replace(CONS.CMS_REGEX, Odigeo.Utils.formatCurrency(this.options.minimumPrice)));

        if (this.options.primeInfo?.isPrimeView) {
            if (Odigeo.AB.isNegativePrimeMarkupBagsSeatsDesktop) {
                this.$cachedSelectors.aircraftmapFrompriceContainer.addClass(CONS.HIDDEN_CLASS);
            } else {
                this.$cachedSelectors.aircraftmapMinimumPricePrime.removeClass(CONS.HIDDEN_CLASS);
                this.$cachedSelectors.aircraftmapMinimumPriceValue.html(
                    Odigeo.Utils.formatCurrency(this.seatMap.minSectionPrimePrices.totalPrice));
                this.$cachedSelectors.aircraftmapMinimumPriceValuePrime.html(
                    Odigeo.Utils.formatCurrency(this.seatMap.minSectionPrimePrices.totalPrimePrice));
            }
            this.$cachedSelectors.aircraftmapMinimumPrice.addClass(CONS.HIDDEN_CLASS);
            this.$cachedSelectors.aircraftmapPreviewSeatPriceContainer.addClass(CONS.HIDDEN_CLASS);
            this.$cachedSelectors.aircraftmapPreviewSeatPricePrimeContainer.removeClass(CONS.HIDDEN_CLASS);
        }
    },
    getSeatInfo: function(seat) {
        return seat.get('rowSelection') + seat.get('columnSelection');
    },
    getActivePassenger: function() {
        const lastTravellerIdx = this.nTravellers;
        let activePassenger = 1;
        let searchPattern;
        let currentPassengerType;
        if (this.passengerCollection.length) {
            if (Odigeo._.size(this.seatMapSelectionCollection.getFlightSeats(this.section)) === this.nEligibleTravellers) {
                activePassenger = this.passengerCollection.getLastNumPassengerExcludingType(CONS.PASSENGER_TYPE_INFANT);
            } else {
                for (let paxCounter = lastTravellerIdx; paxCounter >= 1; paxCounter--) {
                    currentPassengerType = this.passengerCollection.getPassenger({numPassenger: paxCounter}).get('travellerType');
                    if (currentPassengerType != CONS.PASSENGER_TYPE_INFANT) {
                        searchPattern = {numPassenger: paxCounter, section: this.section};
                        activePassenger = Odigeo._.isUndefined(this.seatMapSelectionCollection.getSeat(searchPattern)) ? paxCounter : activePassenger;
                    }
                }
            }
        }
        return activePassenger;
    },
    hideErrorMessage: function() {
        Odigeo.trigger(this.name + ':hideErrors');
    },
    setStatusValue: function($e, value) {
        if (!Odigeo._.isUndefined($e)) {
            $e.attr(CONS.DATA_STATUS, value);
        }
    },
    getStatusValue: function($e) {
        return $e.attr(CONS.DATA_STATUS);
    },
    getSeatDivId: function(row, column) {
        return '#aircraft_map' +
            '_' + row + column;
    },
    getPassengerDivId: function(idPassenger) {
        return '#aircraft_map' +
            '_passenger_' + idPassenger;
    },
    cancelAircraftMoveThrough: function() {
        clearTimeout(this.aircraftLoaderTimeout);
        this.$cachedSelectors.aircraftmapSectionLoader.removeClass('fadeIn');
    },
    checkPassengerCollectionPopulated: function() {
        this.passengerCollectionLoadedDeferred.resolve();
    },
    initAircraftLegend: function(seatAvailabilityByType) {
        this.aircraftMapLegendWidget = this.aircraftMapLegendWidget ? this.aircraftMapLegendWidget.destroy() : null;
        this.aircraftMapLegendWidget = aircraftmapLegendFactory.create({
            el: this.$cachedSelectors.aircrafmapLegend,
            scrollToFirstSeatType: (seatType) => this.scrollToFirstSeatType(aircraftMapUtils.getSeatCharacteristicClassByType(seatType)),
            analyticsEventTracking: (seatType) => this.analyticsEventTracking(seatType),
            seatAvailabilityByType,
        });
    },
    initialize: function() {
        this.init();
        this.passengerCollectionLoadedDeferred = $.Deferred();
        this.passengerCollectionLoadedPromise = this.passengerCollectionLoadedDeferred.promise();
    },
    updateShoppingCart() {
        const {length = 0} = this.seatMapSelectionCollection || {};

        const _fee = this.seatMapSelectionCollection.getSeatSelectionFees();
        const primeFee = this.seatMapSelectionCollection.getSeatSelectionPrimeFees();

        const isSeatsPrimeDiscounts = Odigeo.AB.isSeatsPrimeDiscountsDesktop;
        const totalPrimePrice = isSeatsPrimeDiscounts ? this.seatMapSelectionCollection.getSelectedSeatsPrimePrice() : 0;
        const usePrimePrice = totalPrimePrice > 0 || (isSeatsPrimeDiscounts && length === 0);

        let total = this.seatMapSelectionCollection.getTotalPrice();
        let fee = _fee;
        let primePerks = 0;
        let primePerksFromDapi = 0;

        if (usePrimePrice) {
            const isPriceWithDiscountSelected = Odigeo.Membership.isPriceWithoutDiscountSelected === 'false';

            primePerks = total - totalPrimePrice;
            primePerksFromDapi = this.seatMapSelectionCollection.getPerksFromDapi();
            total = totalPrimePrice;

            if (isPriceWithDiscountSelected) {
                fee = primeFee;
            }
        }

        ShoppingCart.builders.seat.data({
            usePrimePrice,
            price: {
                total,
                fee,
            },
            perks: {
                fromClient: primePerks,
                fromDapi: primePerksFromDapi,
            },
            selection: this.seatMapSelectionCollection,
            quantity: length,
        }).fromWidget().add();

        Odigeo.trigger(this.name + ':updateSidebarSummary', this.seatMapSelectionCollection);
    },
}))));
